import request from '../utils/request';

/**
 * 获取领导力DNA测验题目
 * 请求参数：learningTourId learningTournew api 中的tour_id
 * surveyType DNA测验固定值为1
 */
export function getLeaderShipDNATestData(learningTourId, surveyType) {
    return request.MainService({
        url: `/sr/coursedna/${learningTourId}/showSurvey/${surveyType}`,
        method: 'post',
        data: {}
    });
}

/**
 * DNA计时统计 5s统计一次--2023.10已弃用
 */
// export function putTiming(surveyId) {
//     return request.MainService({
//         url: `/api/surveys/${surveyId}`,
//         method: 'put',
//         data: {}
//     });
// }

/**
 * DNA测验答题
 */
export function submitDNAAnswer(surveyId,questionId,optionId) {
    return request.MainService({
        url: `/sr/coursedna/surveys/${surveyId}`,
        method: 'post',
        data: {'questionId':questionId,'optionId':optionId}
    });
}

/**
 * 重做DNA测验
 */
export function resetDNAAnswer(surveyId) {
    return request.MainService({
        url: `/sr/coursedna/surveys/${surveyId}/reset`,
        method: 'post',
        data: {}
    });
}

/**
 * DNA测验提交
 */
export function submitDNATest(learningTourId, surveyType) {
    return request.MainService({
        url: `/sr/coursedna/${learningTourId}/finishSurvey/${surveyType}`,
        method: 'post',
        data: {}
    });
}

/**
 * DNA测试报告
 */
export function getDNATestReport(surveyId) {
    return request.MainService({
        url: `/sr/coursedna/surveys/${surveyId}/report`,
        method: 'get',
        data: {}
    });
}

/**
 * 获取DNA报告音频与解读
 */
export function getDNATestReportAndAudio() {
    return request.MainService({
        url: `/sr/coursedna/queryCourseDNAList`,
        method: 'get',
        data: {}
    });
}

/**
 * 保存用户DNA音频课程读取记录
 */
 export function submitAudioRecord(unitId, duration) {
    return request.MainService({
        url: `/sr/coursedna/saveDNAUserAudioRecord/${unitId}/${duration}`,
        method: 'post',
        data: {}
    });
}






// WEBPACK FOOTER //
// ./src/api/leadership.js